import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import {RateFieldType} from "@/components/business/crud/interface/FieldType";


export default /*#__PURE__*/_defineComponent({
  __name: 'RateForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

return (_ctx: any,_cache: any) => {
  const _component_a_rate = _resolveComponent("a-rate")!

  return (_openBlock(), _createBlock(_component_a_rate, {
    value: _unref(data)[_ctx.propName],
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data)[_ctx.propName]) = $event)),
    tooltips: _ctx.widget.tips,
    "allow-half": _ctx.widget.half,
    count: _ctx.widget.count,
    disabled: _ctx.info.status === 'show'
  }, null, 8, ["value", "tooltips", "allow-half", "count", "disabled"]))
}
}

})